'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import UITextInput from 'UIComponents/input/UITextInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default class LabelInput extends Component {
  constructor(props) {
    super(props);
    this.onChange = ({
      target: {
        value
      }
    }) => {
      value = value.replace(' ', '');
      this.setState({
        value
      });
    };
    this.onBlur = () => {
      this.props.onKeyChange(this.state.value);
    };
    this.state = {
      value: props.label
    };
  }
  render() {
    const {
      value
    } = this.state;
    return /*#__PURE__*/_jsx(UITextInput, {
      onBlur: this.onBlur,
      onChange: this.onChange,
      value: value
    });
  }
}
LabelInput.propTypes = {
  label: PropTypes.string,
  onKeyChange: PropTypes.func
};